var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlecheOnglet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.977,
    height: 7.488,
    viewBox: "0 0 12.977 7.488",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1108",
    "data-name": "Trac\\xE9 1108",
    d: "M3231.211-441.4l5.074,5.074-5.074,5.074",
    transform: "translate(442.815 3237.286) rotate(-90)",
    fill: "none",
    stroke: "#10254b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlecheOnglet);
export default __webpack_public_path__ + "static/media/fleche-onglet.01c8193770099ee5d65b0429d7635233.svg";
export { ForwardRef as ReactComponent };